import React from "react";

export default function Career() {
  return (
    <main className="pt-28 pb-24">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="ali-chip">Careers</div>
        <h1 className="mt-4 font-satoshi font-black text-4xl sm:text-5xl text-[#0A192F] tracking-tight">Build the future of education with us.</h1>
        <p className="mt-4 text-slate-600 font-inter">We're hiring obsessive teachers, designers and engineers who love education. Send us your story — we read every message.</p>
        <div className="mt-10 space-y-3">
          {[
            { t: "Senior IELTS Coach", l: "Remote · Full time" },
            { t: "Frontend Engineer (React)", l: "New Delhi · Hybrid" },
            { t: "Content Producer (Languages)", l: "Remote · Contract" },
            { t: "Growth Marketer", l: "New Delhi · Full time" },
          ].map((j, i) => (
            <div key={i} className="ali-card p-5 flex items-center justify-between" data-testid={`job-${i}`}>
              <div>
                <p className="font-satoshi font-bold text-[#0A192F]">{j.t}</p>
                <p className="text-xs text-slate-500 font-poppins">{j.l}</p>
              </div>
              <a href="mailto:careers@alearnindia.com" className="ali-btn-outline text-sm py-2.5">Apply</a>
            </div>
          ))}
        </div>
      </div>
    </main>
  );
}
